<template>

    <LoopItemPanel title="Slide">

        <div class="canvas-blocks-sky-price-LoopItemPanel">

            <LinkInput :options="loopItem"></LinkInput>

        </div>
        
        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import LinkInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/LinkInput";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        LinkInput
    },

}
</script>
